import React, { useEffect, useState } from 'react';
import { Trash } from 'lucide-react';
import { withTranslation } from 'react-i18next';
import { Button, Label } from '@cargomatic/ui';
import ErrorLabel from 'components/v2/forms/ErrorLabel';
import CustomerSearch from 'components/site/customer-search';
import FormGrid from './FormGrid';
import { SHIPPER, CARRIER } from 'constants/UserTypes';

const customerTypeSelectMap = new Map([
  [SHIPPER, CARRIER],
  [CARRIER, SHIPPER],
]);

export const CustomerRateConditionField = withTranslation()(
  function CustomerRateConditionField({
    condition,
    onChange,
    onRemove,
    onValidate,
    customerType,
    t,
  }) {
    const { criteria: value, meta } = condition;
    const [customer, setCustomer] = useState(meta?.customer || {});
    const [error, setError] = useState();
    console.log('meta ', meta);
    console.log('customer ', customer);
    console.log('Condition for customer field ', condition);
    const customerTypeSelect =
      customerTypeSelectMap.get(customerType?.toLowerCase()) || 'CUSTOMER';

    useEffect(() => {
      validateCustomerType(customer);
    }, [customerType]);

    function validateCustomerType(customer) {
      let message;
      const customerTypeValid =
        customerTypeSelectMap.get(customer?._type?.toLowerCase()) !==
        customerTypeSelect;
      if (!customerTypeValid) {
        message = t(
          `CUSTOMER_TYPE_MUST_BE_${customerTypeSelect.toUpperCase()}`,
        );
      }

      onValidate(!customerTypeValid, message);
      setError(message);

      return customerTypeValid;
    }

    function handleRemove() {
      onRemove(condition);
    }

    function handleChange(value, customer) {
      if (!validateCustomerType(customer)) {
        return;
      }
      setCustomer(customer);
      onChange({ ...condition, criteria: customer._id, meta: { customer } });
    }

    const renderErrorMessage = () =>
      error && <ErrorLabel className="mt-1">{error}</ErrorLabel>;

    return (
      <FormGrid>
        <Label className="w-48">Customer</Label>
        <div>
          <CustomerSearch
            type={customerTypeSelect}
            onSelect={handleChange}
            placeholder={t(`SEARCH_FOR_${customerTypeSelect.toUpperCase()}`)}
            clearOnSelect={false}
            defaultValue={customer.name || value}
          />
          {renderErrorMessage()}
        </div>

        <div>
          <Button variant="icon" onClick={handleRemove}>
            <Trash className="w-3.5 h-3.5" />
          </Button>
        </div>
      </FormGrid>
    );
  },
);

export default CustomerRateConditionField;
